import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Input,
    InputGroup,
    InputGroupText,
    InputGroupAddon,
    Spinner,
    Row,
    Label,
    Card,
    CardTitle,
} from 'reactstrap';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import 'react-quill/dist/quill.bubble.css';
import { Separator, Colxx } from '../../../../../../../../components/common/CustomBootstrap';
import {
    AxiosAPI,
    getGroupID,
} from '../../../../../../../../helpers/AxiosAPI';
import {
    gAPI_Twilio_Templates,
    postAPI_GuestMessagingReservation_SendMessage
} from '../../../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../../../components/common/react-notifications';
import countryCodes from '../../../../../../../../data/dial_code';
import moment from 'moment';

const STATUS_OPTIONS = [
    { label: 'In House', value: 'InHouse' },
    { label: 'Arrived Today', value: 'ArrivedToday' },
    { label: 'Arrived Yesterday', value: 'ArrivedYesterday' },
    { label: 'Departing Today', value: 'DepartingToday' },
    { label: 'Departing Tomorrow', value: 'DepartingTomorrow' },
    { label: 'Departed Today', value: 'DepartedToday' },
    { label: 'Departed Yesterday', value: 'DepartedYesterday' },
];
const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);
const PLACEHOLDER_VALUE_MAP = {
    guest_first_name: (r) => r?.firstName || '',
    guest_last_name: (r) => r?.lastName || '',
    guest_phone: (r) => r?.phone || '',
    guest_email: (r) => r?.email || '',
    room_number: (r) => r?.roomNumber || '',
    room_type: (r) => r?.roomTypeName || '',
    check_in_date: (r) => formatDate(r?.arrivalDate || ''),
    check_out_date: (r) => formatDate(r?.departureDate || ''),
};
const BULK_LABEL_MAP = {
    guest_first_name: 'First Name',
    guest_last_name: 'Last Name',
    guest_phone: 'Phone Number',
    guest_email: 'Email Address',
    room_number: 'Room Number',
    room_type: 'Room Type',
    check_in_date: 'Arrival Date',
    check_out_date: 'Departure Date',
};

function replacePlaceholdersFromText(template, replacements) {
    return template.replace(/{{(.*?)}}/g, (_, key) => {
        return replacements[key.trim()] || `{{${key}}}`;
    });
}

const styles = `
      .ql-toolbar {  
        border: 1px solid #ccc !important;            
         border-radius: 0px!important;  
         background:white;       
      }

      .ql-container{
        border: 1px solid #ccc !important; 
        border-radius: 0px!important;   
        background:white;      
      }
      
      .dropzone {
        min-height: 40px !important;
        cursor:pointer;
    }
  `;

const SMStab = ({
    propertyId,
    preFillPhoneNumber,
    showStatusFilter = false,
    showPhoneNumber = false,
    reservationId,
    source,
    onStatusChange,
    totalCount,
    loadingCount,
    reservationData
}) => {

    const { userName, timeZone } = useSelector(({ settings }) => ({
        userName: settings.userName,
        timeZone: settings.timeZone,
    }));

    const [templateList, setTemplateList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
    const [AiVoiceData, setAiVoiceData] = useState({
        templateId: '',
        to: '',
        countryCode: '+64',
        rawNumber: preFillPhoneNumber || '',
        text: '',
    });

    useEffect(() => {
        if (statusMessage.text) {
            const timer = setTimeout(() => {
                setStatusMessage({ text: '', type: '' });
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [statusMessage]);

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
        }).then((res) => {
            setTemplateList(res.data);
            if (preFillPhoneNumber !== undefined && preFillPhoneNumber != null) {
                let raw = preFillPhoneNumber || '';
                let dialCode = '+64';
                countryCodes.map((m) => {
                    if (raw.startsWith(m.dial_code)) {
                        raw = raw.replace(m.dial_code, '');
                        dialCode = m.dial_code;
                    }
                });
                setAiVoiceData((prev) => ({
                    ...prev,
                    rawNumber: raw,
                    countryCode: dialCode,
                    to: `${dialCode}${raw}`,
                }));
            }
        });
    }, [propertyId, preFillPhoneNumber]);

    const handleTemplate = (e) => {
        const selectedTemplate = templateList.find(
            (t) => t.id === e.target.value
        );
        if (!selectedTemplate) return;

        const text = selectedTemplate.templateBody || '';

        const placeholders = (selectedTemplate.placeholders || []).map((ph) => {
            const placeholderKey = `{{${ph.name}}}`;
            const value =
                source === 'Manually'
                    ? PLACEHOLDER_VALUE_MAP[ph.value]?.(reservationData) || ''
                    : '';

            return {
                key: placeholderKey,
                sourceKey: ph.value,
                label:
                    BULK_LABEL_MAP[ph.value] ||
                    ph.value.replaceAll('_', ' ').toUpperCase(),
                value,
            };
        });

        setAiVoiceData((prev) => ({
            ...prev,
            templateId: selectedTemplate.id,
            text,
            placeholders,
        }));
    };

    const handlePlaceHolders = (value, index) => {
        let placeholders = [...AiVoiceData.placeholders];
        placeholders[index].value = value;
        setAiVoiceData({ ...AiVoiceData, placeholders: placeholders });
    };

    const sendVoiceCall = async () => {
        try {
            setLoading(true);

            if (AiVoiceData?.countryCode && AiVoiceData?.rawNumber) {

                const UpdatedMessage = replacePlaceholdersFromText(AiVoiceData?.text, {
                    name: reservationData?.firstName || "Guest",
                    hotel: "Grand Hotel"
                });

                const response = await AxiosAPI({
                    method: 'post',
                    url: `${process.env.REACT_APP_BFF_API}/api/guest-message-reservation/outbound-voice-call`,
                    data: {
                        phone: AiVoiceData?.countryCode + AiVoiceData?.rawNumber,
                        welcomeMessage: UpdatedMessage,
                        propertyId: propertyId,
                        groupId: getGroupID(),
                    },
                });
            }
            setStatusMessage({
                text: 'Voice request sent successfully',
                type: 'success',
            });

        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const renderBulkStatus = (msg) => {
        if (!msg) return null;

        // Only format when queued info exists
        if (!msg.toLowerCase().includes("queued")) {
            return msg;
        }

        // Split on both "|" and "," safely
        const parts = msg
            .split(/[\|,]/)
            .map(p => p.trim())
            .filter(p => p !== "");

        const formatPart = (part, color) => {
            if (!part.includes(":")) return part;

            const [label, value] = part.split(":");

            const cleanLabel =
                label.trim().charAt(0).toUpperCase() +
                label.trim().slice(1).toLowerCase();

            const cleanValue = value?.trim();

            return (
                <span style={{ color, fontWeight: 600 }}>
                    {cleanLabel}
                    {cleanValue ? `: ${cleanValue}` : ""}
                </span>
            );
        };

        const header = parts[0]; // Bulk messages processed
        const queuedPart = formatPart(parts[1], "green");
        const failedPart = formatPart(parts[2], "red");

        return (
            <span>
                {header}{" "}
                {queuedPart && <>| {queuedPart} </>}
                {failedPart && <>| {failedPart}</>}
            </span>
        );
    };
    const renderManualStatus = (msg) => {
        if (!msg) return null;

        const normalized = msg.trim().toLowerCase();

        const formatted =
            normalized.charAt(0).toUpperCase() + normalized.slice(1);

        const isQueued = normalized.includes('queued') || normalized.includes('success');

        return (
            <span
                style={{
                    color: isQueued ? 'green' : 'red',
                    fontWeight: 600,
                }}
            >
                {formatted}
            </span>
        );
    };

    return (
        <Fragment>
            <Card className=" mt-2 " style={{ boxShadow: "none" }}>
                <CardTitle className="ml-3">
                    Send Voice Call
                </CardTitle>

                <style>{styles}</style>
                <Row className="ml-2 mr-2">
                    {showStatusFilter && source === 'Bulk' && (
                        <Colxx md="12" className="mb-2">
                            <Label>Select status</Label>
                            <Select
                                className="react-select"
                                classNamePrefix="react-select"
                                options={STATUS_OPTIONS}
                                placeholder="Select status"
                                value={selectedStatus}
                                onChange={(val) => {
                                    setSelectedStatus(val);
                                    if (val && onStatusChange) {
                                        onStatusChange(val.value);
                                    }
                                }}
                                isClearable
                            />
                            {source === 'Bulk' && selectedStatus && (
                                <div className="mt-1" style={{ fontSize: '13px' }}>
                                    {loadingCount ? (
                                        'Fetching guest count...'
                                    ) : (
                                        <b>Voice calls will be sent to {totalCount} guests with valid, unique phone numbers.</b>
                                    )}
                                </div>
                            )}

                        </Colxx>

                    )}

                    <Colxx md="12" className="mb-2">
                        <Label>Template</Label>
                        <Input
                            type="select"
                            name="Template"
                            onChange={handleTemplate}
                        >
                            <option value="">Please Select</option>

                            {Array.isArray(templateList) &&
                                templateList
                                    .filter(
                                        (t) =>
                                            Array.isArray(t.channel) &&
                                            t.channel.some(
                                                (c) => c && c.toLowerCase() === 'phonesuite'
                                            )
                                    )
                                    .map((m) => (
                                        <option key={m.id} value={m.id}>
                                            {m.name}
                                        </option>
                                    ))}
                        </Input>
                    </Colxx>
                    {AiVoiceData?.templateId && AiVoiceData?.templateId !== '' ? (
                        <Fragment>
                            {loading ? (
                                <div className="text-center">
                                    <Spinner color="primary" className="mb-1" />
                                </div>
                            ) : (
                                <Fragment>
                                    <Colxx md="12" className="mb-2">
                                        <Label>Message</Label>
                                        <Input
                                            type="textarea"
                                            value={AiVoiceData?.text}
                                            name="conditions"
                                            disabled={true}
                                        // onChange={handleChangeConditionsArr}
                                        />
                                    </Colxx>

                                    {AiVoiceData.placeholders?.map((ph, index) => (
                                        <Colxx md="12" className="mb-2" key={index}>
                                            <Label>
                                                Placeholder Information
                                            </Label>

                                            <InputGroup>
                                                <InputGroupAddon>
                                                    <InputGroupText style={{ width: '138px' }}>{ph.key}</InputGroupText>
                                                </InputGroupAddon>

                                                <Input
                                                    type="text"
                                                    value={source === 'Bulk' ? ph.label : ph.value}
                                                    disabled={true}
                                                />
                                            </InputGroup>
                                        </Colxx>
                                    ))}

                                    {showPhoneNumber && (
                                        <Colxx md="12" className="mb-2">
                                            <Label>Mobile Number</Label>
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <Input
                                                        type="select"
                                                        name="countryCode"
                                                        value={AiVoiceData.countryCode || '+64'}
                                                        onChange={(e) =>
                                                            setAiVoiceData({
                                                                ...AiVoiceData,
                                                                countryCode: e.target.value,
                                                                to: `${e.target.value}${AiVoiceData.rawNumber || ''
                                                                    }`,
                                                            })
                                                        }
                                                        style={{
                                                            width: '150px',
                                                            textAlign: 'center',
                                                            cursor: 'pointer',
                                                        }}
                                                        disabled
                                                    >
                                                        {countryCodes.map((c) => (
                                                            <option key={c.code} value={c.dial_code}>
                                                                {c.code} {c.dial_code} ({c.name})
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </InputGroupAddon>
                                                {/* <Input
                                                    type="text"
                                                    placeholder="Enter phone number"
                                                    value={AiVoiceData.rawNumber || ''}
                                                    style={{
                                                        backgroundColor: 'white',
                                                        cursor: 'text',
                                                    }}
                                                    onChange={(e) => {
                                                        const number = e.target.value.replace(/\D/g, '');
                                                        setAiVoiceData({
                                                            ...AiVoiceData,
                                                            rawNumber: number,
                                                            to: `${AiVoiceData.countryCode || '+64'}${number}`,
                                                        });
                                                    }}
                                                /> */}
                                                <Input
                                                    type="text"
                                                    value={AiVoiceData.rawNumber || ''}
                                                    placeholder="Not available"
                                                    disabled
                                                />
                                            </InputGroup>
                                            {!AiVoiceData?.rawNumber && (
                                                <div
                                                    style={{
                                                        color: '#dc3545',
                                                        fontSize: '12px',
                                                        marginTop: '5px',
                                                    }}
                                                >
                                                    <b>No mobile number available for this contact.</b>
                                                </div>
                                            )}
                                        </Colxx>
                                    )}
                                </Fragment>
                            )}
                        </Fragment>
                    ) : null}
                </Row>
                <div className="text-center my-3">
                    {statusMessage.text && (
                        <div className="mb-2 font-medium">
                            <b>
                                {source === 'Bulk'
                                    ? renderBulkStatus(statusMessage.text)
                                    : renderManualStatus(statusMessage.text)}
                            </b>
                        </div>
                    )}

                    {AiVoiceData?.templateId && AiVoiceData?.templateId !== '' ? (
                        <>
                            <Separator className="mb-3" />
                            <Button
                                color="primary"
                                size="xs"
                                onClick={sendVoiceCall}
                                disabled={!AiVoiceData?.rawNumber}
                            >
                                Send
                            </Button>
                        </>
                    ) : null}
                    {/* <Button className='ml-2' color="secondary" size="xs" onClick={toggle}>
            Cancel
          </Button> */}
                </div>
            </Card>
        </Fragment>
    );
};

export default SMStab;




